import {useMemo } from "react";
import SsoService from "../services/SSO/SsoService";
import { useAlertContext } from "../components/alert/AlertContext";

const useSsoService = () => {
  const alert = useAlertContext();
  const service = useMemo(() => new SsoService(alert.showAlert), [alert]);
  return service;
};

export default useSsoService;
